
import { css } from '@emotion/css';
import React from 'react';
import AliceCarousel, { DotsItem } from 'react-alice-carousel';
import { Text } from '../../../../../../components';
import 'react-alice-carousel/lib/alice-carousel.css';
import Carousel5 from '../../static/carousel5.png';
import Carousel6 from '../../static/carousel6.png';
import { QuoteIcon } from '../../../../../../components/icons';

// const handleDragStart = (e: React.DragEvent<HTMLDivElement>) =>
//   e.preventDefault();

type ItemProps = {
  children: React.ReactNode;
  title: string;
  description: string;
  value: number;
};
const Item: React.FC<ItemProps> = ({ title, description, children, value }) => {
  return (
    <div
      className={css`
        width: 100%;
        height: 75vh;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        @media (max-width: 825px) {
          height: 50vh;
          padding-top: 24px;
        }
        @media (max-width: 825px) and (min-height: 845px) {
          height: 70vh;
        }
      `}
      data-value={value}
    >
      <div
        className={css`
          width: 100%;
          height: 100%;
          overflow: hidden;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          position: relative;
          @media (max-width: 825px) {
            align-items: flex-start;
          }
        `}
      >
        {children}
      </div>
      <div
        className={css`
          position: absolute;
          bottom: 0;
          max-width: 410px;
          @media (max-width: 825px) {
            bottom: -10px;
          }
        `}
      >
        {title && <Text.H2
          style={{ fontSize: '22px', textAlign: 'center', marginBottom: '4px' }}
        >
          {title}
        </Text.H2>}
        {description && <Text.Body
          style={{
            fontSize: '17px',
            textAlign: 'center',
            color: '#BDBDBD',
            marginTop: '11px',
            lineHeight: '20px',
          }}
          className={css`
            @media (max-width: 825px) {
              display: none;
            }
          `}
        >
          {description}
        </Text.Body>}
      </div>
    </div>
  );
};

const items = [
  <Item
    title="Take control of your inbox today"
    description="Stay focused on what matters. Everything else is organized and easy to retrieve when you need it."
    value={1}
  >
    <img
      src={Carousel5}
      alt="carousel1"
      className={css`
        width: 90%;
        height: auto;
        display: block;
        position: absolute;
        right: 0;
        top: 0;
        @media (max-width: 825px) and (min-height: 845px) {
          width: 76%;
        }
      `}
    />
  </Item>,
  <Item
    title=""
    description=""
    value={2}
  >
    <div
            className={css`
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: flex-start;
                padding-inline: 24px;
              max-width: 642px;
              padding-inline: 24px;
              @media (max-width: 1024px) {
                width: 100%;
                justify-content: flex-start; 
              }
            `}
          >
            <div
              className={css`
                position: relative;
                width: 100%;
                margin-bottom: 16px;
              `}
            >
              <div
                className={css`
                  margin-bottom: 16px;
                `}
              >
                <QuoteIcon
                  fill="highlight/1"
                  style={{ width: '47px', height: '32px' }}
                  className={css`
                  @media (max-width: 510px) {
                    width: 32px;
                    height: 24px;
                  }
              `}
                />
              </div>
              <span className={css`
                font-size: 32px;
                line-height: 40px;
                @media (max-width: 510px) {
                  font-size: 24px;
                  line-height: 32px;
                }
              `}>
                Multiplayer is outstanding. It feels like AI being proactive, not just waiting for prompts and instructions. Having it organize my Google Mail is just a blessing, especially with the suggested replies saved as drafts
              </span>
            </div>
            <Text.Body color="highlight/1">
              Georges M.<br />Senior Relationship Manager
            </Text.Body>
      </div>
  </Item>,
  <Item
    title="See just the emails that need you"
    description="Fewer distractions in your inbox. Replies drafted in your tone, ready to send."
    value={3}
  >
    <img
      src={Carousel6}
      alt="carousel3"
      className={css`
        width: 90%;
        height: auto;
        display: block;
        position: absolute;
        right: 0;
        top: 0;
      `}
    />
  </Item>,
  <Item
    title=""
    description=""
    value={4}
  >
    <div
            className={css`
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: flex-start;
              max-width: 642px;
              padding-inline: 24px;
              @media (max-width: 1024px) {
                width: 90%;
                margin: auto;
                justify-content: flex-start;
              }
            `}
          >
            <div
              className={css`
                position: relative;
                width: 100%;
                margin-bottom: 16px;
                
              `}
            >
              <div
                className={css`
                   margin-bottom: 16px;
                `}
              >
                <QuoteIcon
                  fill="highlight/1"
                  style={{ width: '47px', height: '32px' }}
                  className={css`
                    @media (max-width: 510px) {
                      width: 32px;
                      height: 24px;
                    }
                  `}
                />
              </div>
              <span className={css`
                font-size: 32px;
                line-height: 40px;
                @media (max-width: 510px) {
                  font-size: 24px;
                  line-height: 32px;
                }
              `}>
                Multiplayer has helped my emails so much I wished this was invented sooner.
              </span>

              <Text.Body color="highlight/1">
              Erik R.<br />Tech Security Leader
            </Text.Body>
            </div>
            
      </div>
  </Item>,
];

const renderDotsItem = ({ isActive }: DotsItem) => {
  return (
    <div
      className={css`
        height: 8px;
        width: ${isActive ? 46 : 8}px;
        border-radius: 4px;
        background-color: ${isActive ? '#ffffff' : '#3A393E'};
        margin-left: 8px;
        cursor: pointer;
        transition: 1s ease-in-out width;
      `}
    />
  );
};

const renderPlayPauseButton = () => {
  return '';
};

type LoginCarouselProps = {
  onSlideEnded?: () => void;
};
export const LoginCarousel: React.FC<LoginCarouselProps> = ({
  onSlideEnded,
}) => {
  return (
    <AliceCarousel
      onSlideChanged={(e) => {
        if (e.item === 3) {
          onSlideEnded?.();
        }
      }}
      mouseTracking
      autoPlay
      autoPlayControls
      autoPlayStrategy="action"
      autoPlayInterval={2000}
      animationDuration={1000}
      animationType="slide"
      infinite
      touchTracking={false}
      disableButtonsControls
      items={items}
      renderDotsItem={renderDotsItem}
      renderPlayPauseButton={renderPlayPauseButton}
    />
  );
};